// Colors shared by the Bodyweight trend chart and its overlays.
export const TREND_COLOR = "var(--tracking)";
export const GOAL_COLOR = "var(--gradient-right)";
export const WARN_COLOR = "var(--adh-warn)";
export const MUTED_COLOR = "var(--white-50)";
